import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RelatorioFinanceiro } from '@/features/relatorio/page/financeiro/RelatorioFinanceiro';

const searchSchema = z.object({
    tab: z
        .enum(['geral', 'movimentacoes', 'contas-pagar', 'contas-receber', 'boletos'])
        .default('geral'),
});

export const Route = createFileRoute('/a/relatorio/financeiro/')({
    component: RelatorioFinanceiro,
    validateSearch: searchSchema,
});
